module.exports = __webpack_public_path__ + "img/ddca4c0.png";